import * as React from "react";
import { Link, Typography } from "@material-ui/core";

const Copyright = (props: any) => {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://warpix.xyz/">
        Warpix
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default Copyright;
